exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-116b177c]{text-align:center;margin:auto}", ""]);

// exports
